module.exports = __webpack_public_path__ + "img/int-guideline.4d85a3a4.png";